import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useParams } from "react-router-dom";
import { decodeToken, getToken } from "../../utils/TokenUtils";
import { API_URL, ENDPOINTS } from "../../constants/api";
import axios from 'axios'
const RegistrationLetter = () => {
  const { id, route } = useParams();
  const token = getToken();
  const banner = decodeToken(token, "banner");
  const logo = decodeToken(token, "logo");
  const user_id = decodeToken(token, "id");
  const username = decodeToken(token, "name");
  const [data,setData]=useState([]);
  useEffect(() => {
        const url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/${route}`;
        const fetchData = async () => {
          try {
            const response = await axios.post(url, {student_id:id,user_id},{
              headers: {
                Authorization: token ? `Bearer ${token}` : '',
              },
            });
            
            setData(response.data.data);
            console.log("report data: ",response.data)
          } catch (error) {
            console.error('Error fetching data:', error);
           
          }
        };
    
        fetchData();
      }, [route]);

  useEffect(() => {
    if (data.length<=0) {
      return
    }
    console.log("data: ",data)
    setTimeout(() => {
      window.print();
    }, 500);
  }, [route,id,data]);

  if (data.length<=0) {
      return
    }
  return (
    <div 
      style={{
        border: "1px solid #000000",
        width: "50%",
        height: "21%",
        margin: "20px auto",
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#fff",
        position: "relative",
        padding: "10px",
      }}
    >
      
        <img
          src={`${API_URL}/${banner}`}
          alt="Banner"
          margin="0px auto"
          width="100%"
          height="100px"
          style={{ borderRadius: "30px !important" }}
        />
      
<div
  style={{
    display: "flex",
    alignItems: "center",
    margin: "20px 0",
  }}
>
  {/* Left line */}
  <hr style={{ flex: 1, border: "1px solid #000", marginRight: "10px" }} />

  {/* Text on the right */}
  <span style={{ fontWeight: "bold", fontSize: "16px" }}>
    Taariikhda la daabacay: {new Date().toLocaleDateString("en-GB")}
  </span>
</div>


      <br />
      <h4
  style={{
    marginTop: "10px",
    textTransform: "uppercase",
    fontWeight: 700,
    display: "flex",
    justifyContent: "space-evenly", // or "space-evenly"
    alignItems: "center",
    padding: "0 10px",
    color: "#030714ff",
    fontFamily: "Arial, sans-serif",
    gap: "20px" // controls spacing between the items
  }}
>Foomka Ardayga Cusub
</h4>
<br/>

     

      {data.map((item, index) => (
  <div key={index} style={{fontSize:"18px",}}>
    {Object.entries(item)
      .filter(([key]) => !key.startsWith("_")) // 🚫 skip keys starting with "_"
      .map(([key, value]) => (
        <p key={key} style={{border:"1px solid black",fontWeight:"bold",padding:"6px"}}>
          {key}: <strong>{value}</strong>
        </p>
      ))}
  </div>
  
))}

    {/* Signature */}
<div style={{ marginTop: "40px", textAlign: "left" }}>
  <p
    style={{
      fontSize: "17px",
      fontWeight: "bold",
      marginBottom: "40px",
    }}
  >
    Saxiixa Diwaangeliyaha
  </p>
  <p
    style={{
      fontSize: "17px",
      borderTop: "2px solid #000",
      display: "inline-block",
      paddingTop: "6px",
      minWidth: "220px",
      textAlign: "center",
      fontWeight: "bold",
      letterSpacing: "1px",
    }}
  >
    {username}
  </p>
</div>

{/* Footer */}
<div
  style={{
    marginTop: "40px",
    borderTop: "1px solid #ccc",
    paddingTop: "12px",
    textAlign: "center",
    fontSize: "14px",
    color: "#555",
    fontStyle: "italic",
  }}
>
  <span>Developed By Kaafiye Technology Center (KTC)</span>
</div>


    </div>
  );
};

export default RegistrationLetter;
